import { IDefaultContextT } from "./context.types";

export const DefaultContext: IDefaultContextT = {
  state: {},
  actions: {},
};
